import { store } from "../store/index";
import {
  filterWorkingPart,
  getWorkingPart,
  updateRestHours,
  updateDays,
  sendA3,
  multipleA3,
  allSnap,
  journeysA3,
  multipleJourneysA3,
  listSnapToExport,
} from "../store/actions/WorkingPartActions";

/**
 * List account links
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterWorkingPart(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const getWorkingPartByUuid = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getWorkingPart(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const updateRestHoursByUuid = async (uuid, restHours) => {
  const result = await store.dispatch(updateRestHours(uuid, { restHours }));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const updateDaysBySociety = async (uuid, nifSociety, days) => {
  const result = await store.dispatch(updateDays(uuid, nifSociety, { days }));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const sendWorkingPartToA3 = async (values) => {
  const result = await store.dispatch(sendA3(values));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const sendMultipleA3 = async (values) => {
  const result = await store.dispatch(multipleA3(values));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const getAllSnapshots = async (filter) => {
  const result = await store.dispatch(allSnap(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const sendJourneysToA3 = async (values, companies) => {
  const result = await store.dispatch(journeysA3(values));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const sendMultipleJourneysA3 = async (values) => {
  const result = await store.dispatch(multipleJourneysA3(values));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const listToExport = async (filters) => {
  const result = await store.dispatch(listSnapToExport(filters));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};
